<template>
  <span class="rf-web-checkbox" :id='"rf-qtip-" + cpntId'>
    <input type="checkbox" :id='cpntId' ref="checkbox" :value="cpntValue" :disabled='cpntDisabled' @input="cpntCheckboxModelUpdateModel">
    <label :for='cpntId' :tabIndex='cpntTabIndex' :class='"has-" + cpntMensagemTipo'><span v-html='cpntNome'></span></label>

    <span v-if='cpntMensagem !== "" && cpntMensagem !== null' v-html='cpntMensagem' :class='"has-" + cpntMensagemTipo'></span>
  </span>
</template>

<style scoped>
  /* -------------- rf-web-checkbox ------------- */
  .rf-web-checkbox > input[type=checkbox] {
    display: none;
  }
  .rf-web-checkbox > input[type=checkbox] + label {
    margin: 3px;
  }
  .rf-web-checkbox > input[type=checkbox] + label:before {
    content: "";  
    display: inline-block;  
    width: 22px;  
    height: 22px;
    vertical-align: middle;
    background-color: #fff;  
    border-radius: 2px;  
    border: 1px solid #c9d3dd;

    cursor: pointer;
  }
  .rf-web-checkbox > input[type=checkbox]:checked + label:before {
    content: "\2714";
    color: var(--color-base-03);
    background-color: #F0F0F0; 
    text-align: center;
    line-height: 20px;
    text-shadow: 0px 0px 3px #eee;

    font-size: var(--font-base-soma-14);
  }
  .rf-web-checkbox > input[type=checkbox]:checked:disabled + label:before {
    content: "\2714";
    color: #ccc;
    background-color: #F0F0F0; 
    text-align: center;
    text-shadow: 0px 0px 3px #eee;

    opacity: 0.6;
  }
  .rf-web-checkbox > input[type=checkbox]:disabled + label span {
    color: var(--color-base-02);
    opacity: 0.8;
  }
  .rf-web-checkbox > input[type=checkbox]:disabled + label:before {
    content: "";  
    display: inline-block;  
    width: 22px;  
    height: 22px;
    vertical-align: middle;
    background-color: #F0F0F0;  
    border-radius: 2px;  
    border: 1px solid #c9d3dd;

    opacity: 0.8;
  }
/* ------------------------------------------------------------------------------- */
</style>

<script>
  export default {
    name: 'rf-web-checkbox',
    props: {
      cpntStatus: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntTime: {
        required: false,
        type: [ String, Number ]
      },
      cpntId: {
        required: false,
        type: String,
        default: function () {
          return 'rf-checkbox-' + Math.floor(Math.random() * (9999 - 1000)) + 1000
        }
      },
      cpntNome: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntTabIndex: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return 1
        }
      },
      cpntValue: {
        required: true,
        type: [ String, Number ]
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntExplica: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },
      cpntChecked: {
        type: Array,
        required: true,
        default: function () {
          return []
        }
      },
      cpntChavesModel: {
        type: [ String, Array ],
        required: false,
        default: function () {
          return []
        }
      },
      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
      }
    },
    mounted: function () {
      this.cpntCheckboxModelIniciar()
    },
    methods: {
      cpntCheckboxModelIniciar: function () {
        // CHAMA A FUNÇÃO PARA VERIFICAR SE O CHECK ESTA MARCADO OU NÃO
        this.cpntCheckboxModelVerificaMarcado()      
      },
      cpntCheckboxModelVerificaMarcado: function () {
        this.$refs.checkbox.checked = this.cpntChecked.indexOf(this.$refs.checkbox.value) !== -1
      },
      cpntCheckboxModelUpdateModel: function () {
        // INICIA A VARIAVEL QUE VAI RECEBER O VALOR
        var valor = []

        // VERIFICA SE O VALOR FOI MARCADO
        switch (this.cpntChecked.indexOf(this.$refs.checkbox.value)) {
          case -1:
            valor = this.cpntChecked.concat([ this.$refs.checkbox.value ])
            break
        
          default:
            valor = this.cpntChecked.filter(item => item !== this.$refs.checkbox.value)
            break
        }

        // DISPARA OS EVENTOS PARA ATUALIZAR OS COMPONENTS PAIS
        this.$emit('cpntUpdateModelLocal', { value: valor, model: this.cpntChavesModel, local: true })
        this.$parent.$emit('cpntUpdateModel', { value: valor, model: this.cpntChavesModel, local: false })
      }
    },
    watch: {
      cpntTime: function () {
        this.cpntCheckboxModelVerificaMarcado()
      },
      cpntChecked: function () {
        this.cpntCheckboxModelVerificaMarcado()
      }
    }
  }
</script>
